/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Moving_Time_One_LinerInputs */

const en_exp_moving_time_one_liner = /** @type {(inputs: Exp_Moving_Time_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The time you were actually on the move — red lights, café stops and auto-pause don't count.`)
};

const de_exp_moving_time_one_liner = /** @type {(inputs: Exp_Moving_Time_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeit, in der du wirklich unterwegs warst — Ampeln, Cafépausen und Auto-Pause zählen nicht.`)
};

/**
* | output |
* | --- |
* | "The time you were actually on the move — red lights, café stops and auto-pause don't count." |
*
* @param {Exp_Moving_Time_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_moving_time_one_liner = /** @type {((inputs?: Exp_Moving_Time_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Moving_Time_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_moving_time_one_liner(inputs)
	return de_exp_moving_time_one_liner(inputs)
});